import validate from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.19.2_@types+node@24.5.2_@vue+compiler-sfc@3.5.21_eslint@9.35.0_rollup@4.52.0_sas_793d913b687a867020ce47208e3891b7/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.19.2_@types+node@24.5.2_@vue+compiler-sfc@3.5.21_eslint@9.35.0_rollup@4.52.0_sas_793d913b687a867020ce47208e3891b7/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-to-landing-page": () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/middleware/redirect-to-landing-page.ts")
}